import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=04dfd18c&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04dfd18c')) {
      api.createRecord('04dfd18c', component.options)
    } else {
      api.reload('04dfd18c', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=04dfd18c&", function () {
      api.rerender('04dfd18c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2g0abTc4RpKUY/JS/comp/pricelist.vue"
export default component.exports